exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge[data-v-41259635] {\n    padding: 10px;\n    font-size: .9em;\n}\n.badge .close[data-v-41259635] {\n    margin-left: .25rem;\n    color: inherit;\n    font-size: 100%;\n    text-shadow: 0 1px 0 rgba(#000, .5);\n}\n.font-large[data-v-41259635] {\n    font-size: 1.75em;\n    font-weight: bold;\n}    \n", ""]);

// exports
